module.exports = __webpack_public_path__ + "img/projekt.37080236.jpg";